module.exports = __webpack_public_path__ + "img/logoLogin.68caa0da.png";